export const calculateScale = (contentSize, conteinerSize) => {
  return Math.min(conteinerSize.width / contentSize.width, conteinerSize.height / contentSize.height)
}
